import React from 'react'
import { trimValues } from 'lib/helpers/forms'
import { toBooleanOrNull } from "lib/helpers/parent/forms"

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      createEmergencyContact, // via withMutation
      form: reduxForm // via withRedux
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      createEmergencyContact({
        variables: {
          input: {
            firstName: form.firstName,
            lastName: form.lastName,
            relationshipToCampers: form.relationshipToCampers,
            legalGuardian: toBooleanOrNull(form.legalGuardian),
            primaryPhone: form.primaryPhone,
            alternatePhone: form.alternatePhone,
            pickup: form.pickup === 'true'
          }
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
